import { Button } from "@sellar-io/components";
import { useId } from "react";
import { useForm } from "react-hook-form";
import { Alert } from "../../../../components/alert/Alert";
import {
  Dialog,
  DialogNavigation,
  DialogContent,
  DialogCTA,
} from "../../../../components/modal/Dialog";
import { apiV2AssertError } from "../../../../hooks/api/v2/apiV2Request";
import { useSupplierPaymentInformation } from "../../../../hooks/api/v2/supplierPaymentInformation/useSupplierPaymentInformation";
import { useSupplierPaymentInformationUpdate } from "../../../../hooks/api/v2/supplierPaymentInformation/useSupplierPaymentInformationUpdate";
import {
  EditBankDetailsForm,
  EditBankDetailsFormFieldValues,
} from "./EditBankDetailsForm";

export const UpdateBankDetailsDialog = ({
  active,
  onDismiss,
  supplierPaymentInformationId,
  supplierId,
}: {
  active: boolean;
  onDismiss: () => void;
  supplierPaymentInformationId: number;
  supplierId: number;
}) => {
  const supplierPaymentInformationUpdateMutation =
    useSupplierPaymentInformationUpdate(
      supplierId,
      supplierPaymentInformationId,
    );

  const supplierPaymentInformationQuery = useSupplierPaymentInformation(
    supplierId,
    supplierPaymentInformationId,
    {
      enabled: !!supplierPaymentInformationId,
    },
  );

  const form = useForm<EditBankDetailsFormFieldValues>({
    defaultValues: {
      bankSortCode: supplierPaymentInformationQuery.data?.bankSortCode,
      bankAccountNumber:
        supplierPaymentInformationQuery.data?.bankAccountNumber,
    },
    shouldUseNativeValidation: true,
  });
  const formId = useId();

  const onSubmit = (data: EditBankDetailsFormFieldValues) => {
    supplierPaymentInformationUpdateMutation.mutate(
      {
        bankAccountNumber: data.bankAccountNumber
          ? data.bankAccountNumber
          : null,
        bankSortCode: data.bankSortCode ?? null,
      },
      {
        onSuccess: () => {
          onDismiss();
        },
      },
    );
  };
  return (
    <Dialog active={active} onDismiss={onDismiss}>
      <DialogNavigation
        leftIcon={"CHEVRON_DOWN"}
        onClickLeftIcon={onDismiss}
        title={"Update bank details"}
      />
      {supplierPaymentInformationUpdateMutation.isError && (
        <Alert
          message={
            apiV2AssertError(supplierPaymentInformationUpdateMutation.error)
              ?.response?.data.message ?? "Unknown error"
          }
        />
      )}
      <DialogContent>
        <EditBankDetailsForm onSubmit={onSubmit} form={form} formId={formId} />
      </DialogContent>
      <DialogCTA>
        <Button
          type="submit"
          form={formId}
          loading={
            supplierPaymentInformationUpdateMutation.isPending ||
            (supplierPaymentInformationQuery.isLoading &&
              supplierPaymentInformationQuery.fetchStatus !== "idle")
          }
        >
          Confirm
        </Button>
      </DialogCTA>
    </Dialog>
  );
};
